import axios from '../../../lib/axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL.replace(/\/+$/, '') : '';



export const locationService = {
  // Get countries list
  getCountries: async (query = '') => {
    try {
      const url = query
        ? `${API_BASE_URL}/countries?q=${encodeURIComponent(query)}`
        : `${API_BASE_URL}/countries`;

      const response = await axios.get(url);

      if (response.data.status && response.data.data) {
        return response.data.data.map(country => ({
          id: country.country_id,
          name: country.country_name,
          code: country.country_code,
          phonecode: country.phonecode
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching countries:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch countries');
    }
  },

  // Get states by country ID
  getStates: async (countryId, query = '') => {
    try {
      let url = `${API_BASE_URL}/states?country_id=${countryId}`;
      if (query) {
        url += `&q=${encodeURIComponent(query)}`;
      }

      const response = await axios.get(url);

      if (response.data.status && response.data.data) {
        return response.data.data.map(state => ({
          id: state.state_id,
          name: state.state_name,
          country_id: state.country_id,
          country_code: state.country_code
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching states:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch states');
    }
  },

  // Get cities by country ID and state ID
  getCities: async (countryId, stateId, query = '') => {
    try {
      let url = `${API_BASE_URL}/cities?country_id=${countryId}&state_id=${stateId}`;
      if (query) {
        url += `&q=${encodeURIComponent(query)}`;
      }

      const response = await axios.get(url);

      if (response.data.status && response.data.data) {
        return response.data.data.map(city => ({
          id: city.city_id,
          name: city.city_name,
          country_id: city.country_id,
          state_id: city.state_id,
          state_name: city.state_name,
          country_code: city.country_code
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching cities:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch cities');
    }
  },

  // Get site request list
  getSiteRequests: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/site-request/list`);

      if (response.data.status && response.data.data) {
        return response.data.data.map(site => ({
          id: site.site_id,
          name: site.site_name
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching site requests:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch site requests');
    }
  },

  // Get roles list
  getRoles: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/roles/list`);

      if (response.data.status && response.data.data) {
        return response.data.data.map(role => ({
          id: role.role_id,
          name: role.role_name
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching roles:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch roles');
    }
  },

  // Get purposes list
  getPurposes: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/purposes/list`);

      if (response.data.status && response.data.data) {
        return response.data.data.map(purpose => ({
          id: purpose.purpose_id,
          name: purpose.display_name
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching purposes:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch purposes');
    }
  }
};

export default locationService;
